import { AxiosError } from 'axios'

import { api } from '~/utils/api'

import { insertToast } from '../toasts/services'

export type AdminSettings = {
  id: 'singleton'
  personalTrainersModule: boolean
  createdAt: string
  updatedAt: string
}

export async function getAdminSettings(): Promise<AdminSettings | undefined> {
  try {
    const { data } = await api.get<AdminSettings>('/admin/settings')
    return data
  } catch (error) {
    const e = error as AxiosError<APIError>
    if (e.response?.data?.message) {
      insertToast({
        title: 'Erro ao buscar configurações',
        message: e.response.data.message,
        duration: 4,
        type: 'error',
      })
    }
    return undefined
  }
}

export async function togglePersonalTrainersModule(): Promise<AdminSettings | undefined> {
  try {
    const { data } = await api.patch<AdminSettings>(
      '/admin/settings/personal-trainers/toggle',
    )
    return data
  } catch (error) {
    const e = error as AxiosError<APIError>
    if (e.response?.data?.message) {
      insertToast({
        title: 'Erro ao atualizar',
        message: e.response.data.message,
        duration: 4,
        type: 'error',
      })
    }
    return undefined
  }
}
